// // TODO: Production
export const domain = 'https://data.cea.or.th/service';
// export const domain = 'http://127.0.0.1:8000'
// export const baseUrl = "/admin/";

// TODO: UAT
// export const domain = 'https://ceadata-backend.kisrasprint.com/public';
export const baseUrl = "/";

export const domainCkan = "https://opendata.cea.or.th";


